module.exports = __webpack_public_path__ + "img/6097@2x.343105ff.png";